import {DECK_SHADOW_DEPTH_MOTION, DECK_SHADOW_MOTION_EASE, HOMEMATCH_TINDER_MAX_SHADOWS, SHADOW_CARD_GAP_PX} from "../constants/homematch_tinder_deck_shadows";

type DeckShadowDepthMotion = (typeof DECK_SHADOW_DEPTH_MOTION)[number];

export function getDeckShadowLayerTop(shadowCount: number): string {
    const clampedShadowCount = Math.min(Math.max(shadowCount, 0), HOMEMATCH_TINDER_MAX_SHADOWS);
    const offsetPx = (HOMEMATCH_TINDER_MAX_SHADOWS - clampedShadowCount) * SHADOW_CARD_GAP_PX;

    return offsetPx === 0 ? "0" : `-${offsetPx}px`;
}

export function getClampedShadowDepth(depth: number) {
    return Math.min(depth, HOMEMATCH_TINDER_MAX_SHADOWS - 1);
}

export function getDeckShadowDepthMotion(depth: number): DeckShadowDepthMotion {
    return DECK_SHADOW_DEPTH_MOTION[getClampedShadowDepth(depth)];
}

export function getDeckShadowMotionTransition(reduceMotion: boolean, depth: number) {
    return {
        delay: reduceMotion ? 0 : depth * 0.05,
        duration: reduceMotion ? 0.2 : 0.36,
        ease: DECK_SHADOW_MOTION_EASE
    };
}

export function getDeckShadowMotionVariants(reduceMotion: boolean, target: DeckShadowDepthMotion) {
    if (reduceMotion) {
        return {
            animate: {opacity: target.opacity},
            exit: {opacity: 0},
            initial: {opacity: 0}
        };
    }

    return {
        animate: {opacity: target.opacity, scale: target.scale, y: target.y},
        exit: {opacity: 0, scale: 1.02, y: target.y + 18},
        initial: {opacity: 0, scale: target.scale - 0.06, y: target.y - 10}
    };
}

export function getDeckShadowZIndex(depth: number) {
    return HOMEMATCH_TINDER_MAX_SHADOWS - depth;
}
import {DECK_SHADOW_DEPTH_MOTION, DECK_SHADOW_MOTION_EASE, HOMEMATCH_TINDER_MAX_SHADOWS, SHADOW_CARD_GAP_PX} from "../constants/homematch_tinder_deck_shadows";

type DeckShadowDepthMotion = (typeof DECK_SHADOW_DEPTH_MOTION)[number];

export function getDeckShadowLayerTop(shadowCount: number): string {
    const clampedShadowCount = Math.min(Math.max(shadowCount, 0), HOMEMATCH_TINDER_MAX_SHADOWS);
    const offsetPx = (HOMEMATCH_TINDER_MAX_SHADOWS - clampedShadowCount) * SHADOW_CARD_GAP_PX;

    return offsetPx === 0 ? "0" : `-${offsetPx}px`;
}

export function getClampedShadowDepth(depth: number) {
    return Math.min(depth, HOMEMATCH_TINDER_MAX_SHADOWS - 1);
}

export function getDeckShadowDepthMotion(depth: number): DeckShadowDepthMotion {
    return DECK_SHADOW_DEPTH_MOTION[getClampedShadowDepth(depth)];
}

export function getDeckShadowMotionTransition(reduceMotion: boolean, depth: number) {
    return {
        delay: reduceMotion ? 0 : depth * 0.05,
        duration: reduceMotion ? 0.2 : 0.36,
        ease: DECK_SHADOW_MOTION_EASE
    };
}

export function getDeckShadowMotionVariants(reduceMotion: boolean, target: DeckShadowDepthMotion) {
    if (reduceMotion) {
        return {
            animate: {opacity: target.opacity},
            exit: {opacity: 0},
            initial: {opacity: 0}
        };
    }

    return {
        animate: {opacity: target.opacity, scale: target.scale, y: target.y},
        exit: {opacity: 0, scale: 1.02, y: target.y + 18},
        initial: {opacity: 0, scale: target.scale - 0.06, y: target.y - 10}
    };
}

export function getDeckShadowZIndex(depth: number) {
    return HOMEMATCH_TINDER_MAX_SHADOWS - depth;
}
